import { subDispositionsModel } from "../mappers/models.mapper";

export class dispositionsReceived {
    constructor(dispositionObj) {
        this.canReprogram        = dispositionObj.CanReprogram;        	
        this.dispositionName	 = dispositionObj.Description;      	
        this.endConversation	 = dispositionObj.EndConversation;     	
        this.finishPreview		 = dispositionObj.FinishPreview;      	
        this.dispositionID		 = dispositionObj.Id;       	
        this.order	             = dispositionObj.Orden;
        this.parent              = dispositionObj.Parent;
        this.subDisposition      = subDispositionsModel(dispositionObj.SubDisposition);
    }
}